// Ohut HTTP API -kerros CompanyFunctionsille.
// Perustuu REACT_APP_API_URL -muuttujaan (esim. https://<region>-<project>.cloudfunctions.net)
import { authFetch } from "../Utils/authFetch";
const API_BASE = process.env.REACT_APP_API_URL;

/** Hae yhtiön perustiedot */
export async function getCompanyBaseInfo(companyId) {
  const url = `${API_BASE}/getCompanyBaseInfo?companyId=${encodeURIComponent(companyId)}`;
  const res = await authFetch(url, { method: "GET" });
  if (!res.ok) {
    let err;
    try { err = await res.json(); } catch {}
    throw new Error(err?.error || "getCompanyBaseInfo failed");
  }
  return res.json();
}

/** Päivitä / luo yhtiön perustiedot (upsert) */
export async function updateCompanyBaseInfo(companyId, data) {
  const url = `${API_BASE}/updateCompanyBaseInfo`;
  const payload = { companyId, data };
  const res = await authFetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let err;
    try { err = await res.json(); } catch {}
    throw new Error(err?.error || "updateCompanyBaseInfo failed");
  }
  return res.json();
}